import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TrainingCentersService } from 'projects/services/src/app/API/training-centers.service';
import { getTcDetailForm } from './tc-address-contact-details.component.element';
import { IDFormControl } from '../d-form/d-form.helpers';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { USER_ROLES } from 'src/app/scheme-constants/scheme-constants';
import { BatchService } from 'projects/services/src/app/API/batch.service';

@Component({
	selector: 'app-tc-address-contact-details',
	templateUrl: './tc-address-contact-details.component.html',
	styleUrls: ['./tc-address-contact-details.component.css']
})
export class TcAddressContactDetailsComponent implements OnInit, OnChanges {
	@Input() tcId: string;
	@Input() role: string;
	tcDetailForm = getTcDetailForm()
	tcDetailFormControl: IDFormControl;
	biceDetails: any;
	constructor(
		private trainingCentreService: TrainingCentersService,
		private batchService : BatchService
	) { }

	ngOnChanges(changes: SimpleChanges) {
		console.log(changes)
		this.getTcDetails()
	}

	ngOnInit() {
		this.getTcDetails()
		this.biceDetails = this.batchService.getBiceName()
		console.log(this.biceDetails);

	}
	mapTcDetailsWithForm(tcDetails) {
		console.log(tcDetails)
		const address = tcDetails.address || {}
		const tp = tcDetails.trainingPartner || {};
		const spoc = tcDetails.spoc || {}
		let patch;

		if (tcDetails.userName.includes('TC')) {

			patch = {
				tcName: tcDetails.trainingCentreName,
				tcUserName: tcDetails.userName,
				tpUserName: tp.userName,
				tpName: tp.name,
				address: address.address1 ? address.address1 : address.addressLine,
				landmark: address.landmark,
				pincode: address.pincode,
				state: Helpers.getValueFromObject(address, 'state.name'),
				district: Helpers.getValueFromObject(address, 'district.name'),
				tehsil: Helpers.getValueFromObject(address, 'tehsil.name'),
				village: Helpers.getValueFromObject(address, 'city.name'),
				parliamentaryConstituency: Helpers.getValueFromObject(address, 'parliamentaryConstituency.name'),
				spocName: spoc.firstName,
				email: spoc.email,
				mobileNumber: spoc.mobileNumber,
			}

		} else {

			patch = {
				tcName: tcDetails.firstName,
				tcUserName: tcDetails.userName,
				tpUserName: this.showTPUserName(tcDetails),
				tpName: this.showTPName(tcDetails) || 'N/A',
				address: address.address1 ? address.address1 : address.addressLine,
				landmark: address.landmark,
				pincode: address.pinCode,
				state: tcDetails.userName.includes('EMPLOYER') ? Helpers.getValueFromObject(address, 'state') : Helpers.getValueFromObject(address, 'state.name'),
				district: Helpers.getValueFromObject(address, 'district.name'),
				tehsil: Helpers.getValueFromObject(address, 'tehsil.name'),
				village: Helpers.getValueFromObject(address, 'city'),
				parliamentaryConstituency: Helpers.getValueFromObject(address, 'parliamentaryConstituency.name'),
				spocName: tcDetails.userName.includes('EMPLOYER') ? spoc.firstName : spoc && spoc.primary && spoc.primary.name,
				email: tcDetails.userName.includes('EMPLOYER') ? spoc.email : spoc && spoc.primary && spoc.primary.email,
				mobileNumber: tcDetails.userName.includes('EMPLOYER') ? spoc.mobile : spoc && spoc.primary && spoc.primary.phone,
			}



			}

		this.tcDetailFormControl.patchValues(patch)
	}

	showTPName(trainingCentreData) {
		if (trainingCentreData.userName.includes('EMPLOYER')) {
			return trainingCentreData.createdBy.firstName
		} else if (trainingCentreData.userName.includes('BICE')) {
			return this.biceDetails && this.biceDetails.firstName
		} else if (trainingCentreData.userName.includes('CAMPS')) {
			return trainingCentreData.tpName
		} else {
			return 'N/A'
		}

	}

	showTPUserName(tcDetails) {
		if (tcDetails.userName.includes('BICE')) {
			console.log("bice");
		return	tcDetails.createdBy


		} else {
			return tcDetails && tcDetails.createdBy && tcDetails.createdBy.userName ||  tcDetails && tcDetails.owner
		}




	}

	getTcDetails() {
		if (this.tcId) {
			this.trainingCentreService.getTrainingCentre(this.tcId).subscribe(res => {
				console.log(res);
				this.mapTcDetailsWithForm(res)
			})
		}
		// this.trainingCentreService.getTrainingCentre(tcId).subscribe
	}
}
